<template>
  <table class="default" style="width: 100%;">
    <tbody>
      <tr>
        <td>
          <b-button
            @click="
              testHistoryShowHandler(
                itemInput.test_id,
                itemInput.type === 'subTest'
              )
            "
            >ประวัติการตรวจ</b-button
          >
          <b-modal
            id="testHistoryModal"
            ref="testHistoryModal"
            centered
            size="lg"
            hide-header
            ok-only
          >
            <test-history-modal-component :data="testHistoryData" />
          </b-modal>
        </td>
        <td>Result</td>
        <td colspan="9">
          <b-form-select
            v-model="itemInput.result.value"
            :options="itemInput.result.options"
            text-field="name"
            value-field="value"
          />
        </td>
      </tr>
      <tr v-if="itemInput.result.value === 'Found'">
        <td>Found List</td>
        <td
          v-if="
            itemInput.result.options.find(
              (opt) => opt.value === itemInput.result.value
            ).has_sub_test
          "
          colspan="9"
        >
          <b-form-group class="text-left">
            <b-form-checkbox-group
              v-model="
                itemInput.result.options[
                  itemInput.result.options.findIndex(
                    (opt) => opt.value === itemInput.result.value
                  )
                ].option_value
              "
              stacked
              style="margin: 1rem;"
              @change="
                handler(
                  itemInput.result.options.findIndex(
                    (opt) => opt.value === itemInput.result.value
                  )
                )
              "
            >
              <b-form-checkbox
                v-for="(option, index) in itemInput.result.options.find(
                  (opt) => opt.value === itemInput.result.value
                ).options"
                :key="`option-checkbox-${index}`"
                style="margin: 1rem;"
                :value="option.value ? option.value : option.name"
              >
                <b-row>
                  <b-col cols="auto">{{ option.name }}</b-col>
                  <b-col v-if="option.has_text_field" cols="auto">
                    <b-form-input
                      v-model="
                        itemInput.result.options[
                          itemInput.result.options.findIndex(
                            (opt) => opt.value === itemInput.result.value
                          )
                        ].options[index].text_value
                      "
                      style="height: 1.5rem;"
                      :type="option.input_type"
                      @input="changeTextfieldOptionCheckbox(index)"
                    />
                  </b-col>
                </b-row>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </td>
        <td
          v-else-if="
            itemInput.result.options.find(
              (opt) => opt.value === itemInput.result.value
            ).has_text_field
          "
          colspan="9"
        >
          <b-form-input
            v-model="
              itemInput.result.options[
                itemInput.result.options.findIndex(
                  (opt) => opt.value === itemInput.result.value
                )
              ].option_value
            "
            placeholder="พิมพ์ผลตรวจ"
            :type="
              itemInput.result.options.find(
                (opt) => opt.value === itemInput.result.value
              ).input_type
            "
            @input="changeTextFieldFoundOption"
          />
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <th>
          <b-form-checkbox
            v-model="itemInput.use_outlab"
            :value="true"
            :unchecked-value="false"
            style="text-align: left;"
            >ใช้ผลตรวจนอก</b-form-checkbox
          >
        </th>
        <th colspan="9">
          <file-upload-component
            :file-upload.sync="itemInput.files"
            :item-index="itemInput.id"
          />
        </th>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import FileUploadComponent from "../FileUploadComponent";
import TestHistoryModalComponent from "../TestHistoryModalComponent";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BloodParasite",
  components: {
    FileUploadComponent,
    TestHistoryModalComponent,
  },
  props: {
    test: {},
  },
  data() {
    return {
      testHistoryData: [],
    };
  },
  computed: {
    ...mapGetters({
      animal: "Animal/getData",
    }),
    itemInput: {
      get() {
        return this.test;
      },
      set(val) {
        this.$emit("update:test", val);
      },
    },
  },
  methods: {
    ...mapActions({
      getLastResultOfAnimal: "Result/getLastResultOfAnimal",
    }),
    handler(index) {
      this.$nextTick(() => {
        if (
          typeof this.itemInput.result.options[index].option_value === "object"
        ) {
          this.itemInput.result.options[
            index
          ].option_value = this.itemInput.result.options[
            index
          ].option_value.filter((option) => {
            return option !== null && option !== false && option !== true;
          });
        }
      });

      //
    },
    changeTextfieldOptionCheckbox(index) {
      // const oldValue = this.itemInput.result.options.find(opt => opt.value === this.itemInput.result.value).options[index].value
      // const optionIndex = this.itemInput.result.options.findIndex(opt => opt.value === this.itemInput.result.value)
      // this.itemInput.result.options[optionIndex].options[index].value = this.otherFoundSolution
      // this.itemInput.result.options[optionIndex].option_value.push(this.otherFoundSolution)
      // const optionsValue = this.itemInput.result.options.find(opt => opt.value === this.itemInput.result.value).options.map(option => option.value)
      // this.itemInput.result.options[optionIndex].option_value = this.itemInput.result.options[optionIndex].option_value.filter(val => val !== oldValue && optionsValue.includes(val))
    },
    async testHistoryShowHandler(testId, isSubTest = false) {
      this.$store.state.isLoading = true;
      const animalId = this.animal.id;
      this.testHistoryData = [];
      let res;
      try {
        res = await this.getLastResultOfAnimal({ animalId, testId, isSubTest });
      } catch (err) {
        this.$swal.fire("Error", err.message, "error");
        this.$store.state.isLoading = false;

        return;
      }
      this.testHistoryData = res;
      this.$refs.testHistoryModal.show();
      this.$store.state.isLoading = false;
    },
  },
};
</script>

<style scoped></style>
